export default "__VITE_ASSET__4de7c7b5__"